module.exports = __webpack_public_path__ + "static/header-noplay.4b2ef59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/header-noplay.png
// module id = 464
// module chunks = 75205924225882